import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'tags'
const verb = 'put'

export default class OspreyTagUpdate extends BaseAction {
    constructor(dataKey) {
        const id = '60bac4d5-17cd-482f-bd0e-ee16f0d425134'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    update(tag) {
        if (!tag) {
            throw new Error('Missing tag object')
        }
        this.path = `/${resource}/${tag.id.value}`

        this.params = {
            name: { value: tag.name.value }
        }

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/tags/tags-update.js